import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import TitleAdvancedFieldsConfig from "segments/desktop/core-components/title/advanced-field-config";
import ParagraphAdvancedFieldsConfig from "segments/desktop/core-components/paragraph/advanced-fields-config";
import AdvancedThemeConfig from "segments/core-configs/advanced-theme-config";

const { titleWidth, ...restTitleAdvancedProps } = TitleAdvancedFieldsConfig;

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    ...SharedAdvancedFieldsConfig,
    ...AdvancedThemeConfig,
    titleAdvancedProps: {
      type: FIELD_TYPES.NESTED,
      label: "Title",
      fields: restTitleAdvancedProps
    },
    paragraphAdvancedProps: {
      type: FIELD_TYPES.NESTED,
      label: "Paragraph",
      fields: ParagraphAdvancedFieldsConfig
    },
    alignToLogo: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Align to logo (New)"
    },
    paragraphVerticalAlignment: {
      type: FIELD_TYPES.COMBO,
      label: "Paragraph vertical alignment",
      options: [
        { value: "baseline", text: "Top" },
        { value: "center", text: "Center" },
        { value: "end", text: "Bottom" }
      ]
    }
  }
};
